import * as React from 'react'
// libs
import cn from 'classnames'
// components
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import ContactSection from '../components/sections/Contact'
// hooks
import { HIDE_CONTACT_HEADER_KEY, Themes, useTheme } from '../hooks/useTheme'

const Contact = ({ isEu = false }) => {
  const { theme } = useTheme()

  const isLightTheme = theme === Themes.LIGHT
  const shouldShowHeader =
    localStorage.getItem(HIDE_CONTACT_HEADER_KEY) !== 'true'

  return (
    <>
      <div id='smooth-wrapper'>
        <div id='smooth-content'>
          <div
            className={cn(
              'podio',
              {
                'podio--light': isLightTheme,
              },
              'contact-page-container'
            )}
          >
            <ContactSection />
            <Footer isEu={isEu} />
          </div>
        </div>
      </div>
      {shouldShowHeader && <Header />}
    </>
  )
}

export default Contact
